// extracted by css-extract-rspack-plugin
export default {"table":"K7EZujH2miwNt3TY","refreshing":"Q9c6HD6u_WENpDkI","loadMore":"acLn7VOqNQI3aMyl","loadMoreError":"KzZKIio1dk9o8g5x","empty":"o57JkR7RM9stBS58"};